import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MailApiClient } from '@trp/community/mail/api-client';

@Component({
  standalone: true,
  selector: 'trp-email-test',
  templateUrl: './email-test.component.html',
  styleUrls: ['./email-test.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatRippleModule, MatSnackBarModule],
})
export class EmailTestComponent {
  sendingTestEmail = false;
  // Mode 2 (webhook) temporarily disabled — see the commented method below.
  // triggeringWebhook = false;

  constructor(
    private mailApiClient: MailApiClient,
    private snackBar: MatSnackBar
  ) {}

  sendTestEmail() {
    if (this.sendingTestEmail) return;
    this.sendingTestEmail = true;
    this.mailApiClient
      .sendTransactionalEmail({
        subject: 'RPS Hub — test transactional email',
        bodyContent: 'This is just a test of the RPS Hub transactional email pipeline.',
        actionButtonText: 'Go to RPS Hub',
      })
      .subscribe({
        next: () => {
          this.sendingTestEmail = false;
          this.snackBar.open('Test email sent — check your inbox.', 'Dismiss', { duration: 5000 });
        },
        error: () => {
          this.sendingTestEmail = false;
          this.snackBar.open('Failed to send the test email.', 'Dismiss', { duration: 5000 });
        },
      });
  }

  // Mode 2 (webhook) temporarily disabled — hits the dev-only, data-mutating
  // POST /mail/test/trigger-webhook. Kept commented (not removed) so it can be
  // re-enabled together with the button in email-test.component.html, the
  // client method in mail.api-client.ts and the endpoint in mail.controller.ts.
  // triggerApprovedViaWebhook(nationalDbId: string) {
  //   const trimmed = (nationalDbId ?? '').trim();
  //   if (this.triggeringWebhook || !trimmed) return;
  //   this.triggeringWebhook = true;
  //   this.mailApiClient.triggerApprovedViaWebhook(trimmed).subscribe({
  //     next: () => {
  //       this.triggeringWebhook = false;
  //       this.snackBar.open('Webhook fired — check your inbox.', 'Dismiss', { duration: 5000 });
  //     },
  //     error: () => {
  //       this.triggeringWebhook = false;
  //       this.snackBar.open(
  //         'Failed to trigger the webhook (check the nationalDbId / dev proxy).',
  //         'Dismiss',
  //         { duration: 6000 }
  //       );
  //     },
  //   });
  // }
}
